import React from 'react';
import InfoCard from './InfoCard';
import clock from '../../assets/icons/clock.svg';
import marker from '../../assets/icons/marker.svg';
import phone from '../../assets/icons/phone.svg';

const Info = () => {
    return (
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-5 py-7">
            <InfoCard cardTitles="Opening Hours"  bgColors="bg-gradient-to-r from-secondary to-primary"img={clock}></InfoCard>
            <InfoCard cardTitles="Ours Locations" bgColors="bg-[#3A4256]" img={marker}></InfoCard>
            <InfoCard cardTitles="Contact Us"     bgColors="bg-gradient-to-r from-secondary to-primary" img={phone}></InfoCard>
        </div>
    );
};

export default Info;